const SESSION_SCOPED_KEYS = new Set([
  'flowDeskAuthSession',
  'flowDeskCurrentUser',
  'flowDeskSyncConnection',
  'pixelFlowUserName',
  'pixelFlowUserPhoto',
  'pixelFlowUserRole'
]);

const getStoredAuthSession = () => {
  try {
    const saved = localStorage.getItem('flowDeskAuthSession') || sessionStorage.getItem('flowDeskAuthSession');
    return saved ? JSON.parse(saved) : null;
  } catch {
    return null;
  }
};

const shouldPersistSessionKey = (key, data) => {
  if (!SESSION_SCOPED_KEYS.has(key)) return true;
  if (key === 'flowDeskAuthSession') return Boolean(data?.rememberMe);
  return Boolean(getStoredAuthSession()?.rememberMe);
};

const getBrowserStoreForSave = (key, data) => (
  shouldPersistSessionKey(key, data) ? localStorage : sessionStorage
);

const getBrowserStoreForLoad = (key) => {
  if (!SESSION_SCOPED_KEYS.has(key)) return localStorage;
  return localStorage.getItem(key) !== null ? localStorage : sessionStorage;
};

export const createLocalStorageAdapter = () => ({
  save: async (key, data) => {
    try {
      if (window.electronAPI?.saveData) {
        return await window.electronAPI.saveData(key, data);
      }

      const targetStore = getBrowserStoreForSave(key, data);
      const otherStore = targetStore === localStorage ? sessionStorage : localStorage;
      targetStore.setItem(key, JSON.stringify(data));
      otherStore.removeItem(key);
      return true;
    } catch (error) {
      console.error('Error saving FlowDesk data:', error);
      return false;
    }
  },

  load: async (key, defaultValue) => {
    try {
      if (window.electronAPI?.loadData) {
        const data = await window.electronAPI.loadData(key);
        return data !== undefined && data !== null ? data : defaultValue;
      }

      const saved = getBrowserStoreForLoad(key).getItem(key);
      if (!saved) return defaultValue;

      try {
        return JSON.parse(saved);
      } catch {
        return saved;
      }
    } catch {
      return defaultValue;
    }
  },

  clear: async () => {
    try {
      if (window.electronAPI?.clearAllData) {
        return await window.electronAPI.clearAllData();
      }

      localStorage.clear();
      sessionStorage.clear();
      return true;
    } catch {
      return false;
    }
  }
});

export const DiskStorage = createLocalStorageAdapter();
